import { HostBinding, Component, OnInit, Injector, Input, Pipe, PipeTransform } from '@angular/core';
import { filter, isEmpty, isArray, includes, uniqueId } from 'lodash';
import { EventsComponent } from '../events/events.component';

@Pipe({ name: 'ricName' })
export class RoundImageNamePipe implements PipeTransform {
	transform(parentName: string): string {
		return parentName + uniqueId();
	}
}

@Component({
	selector: 'round-image-container',
	template: `
		<div class="round-image-container" [ngClass]="{ disabled: control.disabled }" role="group" [attr.gtm]="gaLabel">
			<div class="round-image-list">
				<round-image
					*ngFor="let option of showOptions"
					[isSelected]="isSelected(option.value)"
					[option]="option"
					[ngClass]="{ disabled: control.disabled, error: error }"
					(ToggleRoundImage)="onToggle(option.value)"
					[control]="control"
					[value]="option.value"
					[parentName]="control.name"
					context="page"
					[setAnswer]="setAnswer"
					id="{{ name | ricName }}"
				>
				</round-image>
			</div>
			<more-button
				class="more-button"
				*ngIf="isShowMoreButton()"
				[options]="control.options"
				[isMoreOpen]="isOpen"
				[selected]="value"
				title="More"
				mode="{{ mode }}"
				[ngClass]="{ disabled: control.disabled, error: error }"
				(isOpen)="isHiddenOpen()"
				[isDisabled]="control.disabled"
				[arrOffset]="maxNumOfOptions"
			>
			</more-button>
			<toggle-visible [isOpen]="isOpen" (focusLost)="isHiddenOpen()" (closeOnClick)="isHiddenOpen()">
				<div class="multiselect-checkbox-wrapper" *ngIf="isOpen">
					<round-image-multiselect
						[options]="hiddenOptions"
						(ToggleRoundImageMultiSelect)="onToggle($event.value)"
						(CloseDropDownListOnTabExit)="onTabExit()"
						[isOpen]="isOpen"
						[mode]="mode"
						[parentValue]="value"
					>
					</round-image-multiselect>
				</div>
			</toggle-visible>
		</div>
	`,
	styleUrls: ['./round-image-container.component.scss'],
})
export class RoundImageContainerComponent extends EventsComponent implements OnInit {
	mode: any;
	error: any;
	radio: any;
	multi: any;
	isOpen: boolean;
	maxNumOfOptions: number;
	showOptions: any;
	hiddenOptions: any;
	BP = {
		1: 400,
		3: 750,
		4: 850,
	};
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	constructor(injector: Injector) {
		super(injector);
		this.radio = 'radio';
		this.multi = 'multi';
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (this.value) {
			this.reportPrefill();
		}
		this.mode = this.getMode();
		this.maxNumOfOptions = this.calcMaxNumOfOptions();
		this.hiddenOptions = this.getHiddenOptions();
		this.showOptions = this.control.options.slice(0, this.maxNumOfOptions);
		this.isOpen = false;
	}

	getMode() {
		return this.control.attributes.maxLength === 1 ? this.radio : this.multi;
	}
	getHiddenOptions() {
		return this.control.options.slice(this.maxNumOfOptions, this.control.options.length);
	}

	isSelected(value) {
		switch (this.mode) {
			case 'radio':
				return this.value === value;
			case 'multi':
				return includes(this.value, value);
		}
	}

	isHiddenOpen() {
		this.isOpen = !this.isOpen;
	}

	onToggle(value) {
		if (this.control.disabled) {
			return;
		}

		// when remove
		if (this.isSelected(value)) {
			this.remove(value);
			this.reportEditedPrefillValue();
			return;
		}

		// when add
		this.add(value);

		if (this.control.attributes.maxLength === 1) {
			this.isOpen = false;
		}

		this.reportEditedPrefillValue();
	}

	remove(value) {
		if (this.mode === this.radio) {
			this.setAnswer(null);
			this.value = '';
		}

		if (this.mode === this.multi) {
			let ans = filter(this.value, (o) => o !== value);
			ans = isEmpty(ans) ? null : ans;
			this.setAnswer(ans);
			this.value = ans;
		}
	}

	add(value) {
		switch (this.mode) {
			case this.radio:
				this.value = value;
				this.setAnswer(value);
				break;

			case this.multi:
				// initialize answer as an empty array if set to null
				if (!this.value) {
					this.value = [];
					this.setAnswer([]);
				}

				// wait for digest to finish so this.value will be properly fetched from Store
				setTimeout(() => {
					// do not setAnswer if conditions aren't met
					if (this.value.length >= this.control.attributes.maxLength || includes(this.value, value)) {
						return;
					}

					this.setAnswer([...this.value, value]);
					this.value = [...this.value, value];
				}, 0);
				break;
		}
	}

	isShowMoreButton() {
		return this.control.options.length > this.maxNumOfOptions;
	}

	// sets the max num of options to render based on the width of round-image-container
	calcMaxNumOfOptions() {
		const innerWidth = window.innerWidth;

		switch (true) {
			case innerWidth < this.BP[1]:
				return 3;

			default:
				return 4;
		}
	}

	onTabExit() {
		this.isOpen = false;
	}

	// todo [limitTo]: maxNumOfOptions"
}
